import { render, staticRenderFns } from "./createTicketByNewOrReCount.vue?vue&type=template&id=1fb621b1&"
import script from "./createTicketByNewOrReCount.vue?vue&type=script&lang=js&"
export * from "./createTicketByNewOrReCount.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports